export * from './duna/nav/nav.component';
export * from './main/main.component';
export * from './duna/footer/footer.component';
export * from './duna/duna-frontpage/duna-frontpage.component';
export * from './heading/heading.component';
export * from './text/text.component';
export * from './duna/duna-login/duna-login.component';
export * from './duna/duna-contact/duna-contact.component';
export * from './duna/duna-add-event/duna-add-event.component';
export * from './duna/duna-add-event-users/duna-add-event-users.component';
export * from './duna/duna-edit-event/duna-edit-event.component';
export * from './duna/duna-user-participate/duna-user-participate.component';
export * from './duna/duna-events-calendar/duna-events-calendar.component';
export * from './duna/duna-events-filter/duna-events-filter.component';
export * from './duna/duna-faq/duna-faq.component';
export * from './duna/graph/graph.component';
export * from './dynamic-table/dynamic-table.component';
export * from './dynamic-tabs/dynamic-tabs.component';
export * from './component-container/component-container.component';
export * from './dynamic-form/dynamic-form.component';
export * from './dynamic-infomodal/dynamic-infomodal.component';
export * from './material/material.component';
export * from './duna/duna-dashboard/duna-dashboard.component';
// CMS: dashboard admin (orgadmin/superadmin) → app-duna-dashboard-admin
export * from './duna/duna-dashboard-admin/duna-dashboard-admin.component';
// CMS: offentlig delt dashboard slug/path `/shared-dashboard/:uuid` (uden nav/footer) → app-duna-dashboard-public
export * from './duna/duna-dashboard-public/duna-dashboard-public.component';
export * from './duna/duna-ressource-overview/duna-ressource-overview.component';
export * from './duna/duna-mine-stationer/duna-mine-stationer.component';
export * from './duna/duna-profile-user/duna-profile-user.component';
export * from './duna/duna-user-profile-ep-wizard/duna-user-profile-ep-wizard.component';
export * from './duna/duna-accounttypes/duna-accounttypes.component';
export * from './duna/duna-location-information/duna-location-information.component';
export * from './duna/duna-list-users/duna-list-users.component';
export * from './duna/duna-list-locations/duna-list-locations.component';
export * from './duna/duna-location-page/duna-location-page.component';
export * from './duna/duna-events-information/duna-events-information.component';
export * from './duna/duna-event-users/duna-event-users.component';
export * from './duna/duna-educational-path-info/duna-educational-path-info.component';
export * from './duna/duna-educational-path-version-select/duna-educational-path-version-select.component';
export * from './duna/duna-educational-path-modules/duna-educational-path-modules.component';
export * from './duna/duna-modules-subtypes/duna-modules-subtypes.component';
export * from './duna/duna-org-settings/duna-org-settings.component';
export * from './changelog/changelog.component';
export * from './changelog-create/changelog-create.component';
export * from './duna/duna-template-to-events/duna-template-to-events.component';
export * from './media-test/media-test.component';
export * from './duna/duna-documents/duna-documents.component';
export * from './media-preview/media-preview.component';
export * from './duna/duna-report-generator/duna-report-generator.component';
export * from './duna/duna-advi/duna-advi.component';
export * from './duna/duna-users/duna-users.component';
export * from './duna/duna-manual-maintenance-minutes/duna-manual-maintenance-minutes.component';
export * from './duna/duna-catering/duna-catering.component';
export * from './duna/duna-catering-wishes/duna-catering-wishes.component';
export * from './duna/duna-catering-unique-links/duna-catering-unique-links.component';
export * from './duna/duna-catering-groups/duna-catering-groups.component';
export * from './duna/duna-catering-unique-events/duna-catering-unique-events.component';
// CMS: admin-katalog til catering-ekstra → app-duna-catering-extra-options (GET/POST/PATCH/DELETE /events/catering/extra-options)
export * from './duna/duna-catering-extra-options/duna-catering-extra-options.component';
// CMS: kursusprisskabeloner → app-duna-event-price-templates (GET/POST/PATCH/DELETE /events/course-price-templates)
export * from './duna/duna-event-price-templates/duna-event-price-templates.component';
// CMS: price-extras katalog → app-duna-event-price-extra-options (GET/POST/PATCH/DELETE /events/price-extra-options)
export * from './duna/duna-event-price-extra-options/duna-event-price-extra-options.component';
// CMS: offentlig events-side slug/path `/cleaning/:uuid` → app-duna-cleaning-unique-events; admin-side til links → app-duna-cleaning-unique-links
export * from './duna/duna-cleaning-unique-links/duna-cleaning-unique-links.component';
// CMS: superadmin Keycloak org user sync status → app-duna-cprng-orgsync (GET/POST /organizations/identity-sync/*)
export * from './duna/duna-cprng-orgsync/duna-cprng-orgsync.component';
// CMS: superadmin org JSONB + CPRNG features → app-duna-cprng-orgsettings
export * from './duna/duna-cprng-orgsettings/duna-cprng-orgsettings.component';
// CMS: superadmin API route catalog → app-duna-cprng-endpoints (GET /cprng/endpoints)
export * from './duna/duna-cprng-endpoints/duna-cprng-endpoints.component';
export * from './duna/duna-cleaning-unique-events/duna-cleaning-unique-events.component';
export * from './duna/duna-event-instructors/duna-event-instructors.component';
export * from './duna/duna-event-instructors-respond/duna-event-instructors-respond.component';
export * from './duna/duna-materials-overview/duna-materials-overview.component';
export * from './duna/duna-materials-event/duna-materials-event.component';
export * from './duna/duna-event-ics/duna-event-ics.component';
export * from './duna/duna-ics-online/duna-ics-online.component';
export * from './duna/duna-user-settings/duna-user-settings.component';
export * from './duna/duna-user-catering-preferences/duna-user-catering-preferences.component';
export * from './duna/duna-locations-and-rooms/duna-locations-and-rooms.component';
export * from './duna/duna-event-info/duna-event-info.component';
export * from './duna/duna-event-extra/duna-event-extra.component';
// CMS: kundedatabase + fakturering → app-duna-customers (GET/POST/PATCH/DELETE /organizations/customers)
export * from './duna/duna-customers/duna-customers.component';
export * from './duna/duna-user-groups/duna-user-groups.component';
export * from './duna/duna-user-groups-location/duna-user-groups-location.component';
export * from './duna/duna-events-group-calendar/duna-events-group-calendar.component';
export * from './duna/duna-user-groups-location-calendar/duna-user-groups-location-calendar.component';
// CMS: OAuth/OIDC-klienter (kun superadmin) → app-duna-oauth-clients
export * from './duna/duna-oauth-clients/duna-oauth-clients.component';
// CMS: RCMS adgangsgrupper (kun superadmin) → app-duna-cprng-access-groups
export * from './duna/duna-cprng-access-groups/duna-cprng-access-groups.component';
// CMS: demo-seed org 11 (superadmin, kun test) → app-duna-cprng-seeder
export * from './duna/duna-cprng-seeder/duna-cprng-seeder.component';